class AuthorizationManager {
    token() {
        throw new Error("You have to implement the method");
    }
}

export default AuthorizationManager;